/**
 * Base entity class for all things in the pixel world.
 * Entities have a grid position, world coordinates, depth, and can draw themselves.
 */

import { gridToWorld, depthKey } from "../engine/IsoMath.js";

export abstract class Entity {
  id: string;
  gridCol: number;
  gridRow: number;
  worldX = 0;
  worldY = 0;
  depth = 0;
  visible = true;
  /** Whether this entity casts a ground shadow. */
  castsShadow = false;

  /**
   * Layer for depth sorting.
   *   0 = floor tiles
   *   1 = furniture (lower pieces)
   *   2 = characters / furniture tops
   *   3 = effects / particles
   */
  layer = 0;

  constructor(id: string, col: number, row: number, layer = 0) {
    this.id = id;
    this.gridCol = col;
    this.gridRow = row;
    this.layer = layer;
    this.updateWorldPosition();
  }

  /** Recompute world position and depth from grid coords. */
  updateWorldPosition(): void {
    const { x, y } = gridToWorld(this.gridCol, this.gridRow);
    this.worldX = x;
    this.worldY = y;
    this.depth = depthKey(this.gridCol, this.gridRow, this.layer);
  }

  /** Update entity state. dt is in seconds. */
  abstract update(dt: number): void;

  /** Draw entity to the canvas at its world position. */
  abstract draw(ctx: CanvasRenderingContext2D): void;
}
